import axiosInstance from "../../../axios/axios";

export function getHandlerShows() {

    return new Promise((resolve, reject) => {
        axiosInstance.get(`/handlers/getcompetitions`).then(response => {
            if (response.status == 200) {
                if (response.data?.status?.responseCode == "200") {
                    resolve(response.data?.result ?? []);
                }
            }
            resolve([]);
        }).catch(error => reject([]));
    })
}
export function registerInHandlerShow(showId) {
    const ownerId = localStorage.getItem('currentSubAccountId')??'';
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/handlers/registrationhandler?competitionId=${showId}&ownerId=${ownerId}`).then(response => {
            if (response.status == 200) {
                resolve(response.data ?? false);
            }
            resolve(false);
        }).catch(error => reject(false));
    })
}